import React from "react";
import moment from "moment";

export default class ItemLog extends React.Component {
  render() {
    const now = moment();
    const { entity, log } = this.props;
    // When a veto assignment has been submitted, the descriptive veto log entry
    // already conveys the transition, so hide the generic "set to Veto Person
    // Assigned" line to avoid a redundant duplicate in the panel. (OrderAction's
    // status detection reads order.log directly and is unaffected.)
    const hasVetoSubmit = (log || []).some(
      (i) =>
        i.detail &&
        i.detail.veto_assignment &&
        i.detail.veto_assignment.mode === "submitted"
    );
    const displayLog = (log || []).filter(
      (i) => !(hasVetoSubmit && i.action === "to:Veto Person Assigned")
    );
    // log token
    // console.log("accessToken", this.props.accessToken);
    return (
      <div className="widget">
        <div className="widget-header">
          <h3>
            <i className="fa fa-fire" /> Log
          </h3>
        </div>
        <div className="widget-content">
          <ul className="list-unstyled activity-list">
            {displayLog &&
              displayLog
                // created_at berbutir detik — event beruntun (mis. submit lalu
                // perubahan status) bisa seri, jadi tie-break pakai id insert.
                .sort((a, b) => b.created_at - a.created_at || b.id - a.id)
                .map((item) => {
                  const createdAt = moment.unix(item.created_at);
                  const diff = now.diff(createdAt, "days");
                  const diffHours = now.diff(createdAt, "hours") % 24;
                  const diffMinutes =
                    now.diff(createdAt, "minutes") % (24 * 60);

                  const diffMinuteString =
                    diffMinutes <= 0
                      ? "just now"
                      : diffMinutes === 1
                      ? "1 minute ago"
                      : `${diffMinutes} minutes ago`;
                  const diffHourString =
                    diffHours <= 0
                      ? diffMinuteString
                      : diffHours === 1
                      ? "1 hour ago"
                      : `${diffHours} hours ago`;
                  const diffString =
                    diff <= 0
                      ? diffHourString
                      : diff === 1
                      ? "1 day ago"
                      : `${diff} days ago`;
                  const who = item.user ? item.user.name : "schedule";
                  let actionString;
                  if (item.detail && item.detail.veto_assignment) {
                    const va = item.detail.veto_assignment;
                    const modeText =
                      va.mode === "submitted" ? "submitted" : "saved as draft";
                    // In-place edit (AC-2) carries a `changes` diff — show WHAT
                    // changed instead of the full roster.
                    const ch = va.changes;
                    let detailText;
                    if (
                      ch &&
                      ((ch.removed && ch.removed.length) ||
                        (ch.added && ch.added.length) ||
                        (ch.standards_changed && ch.standards_changed.length))
                    ) {
                      const parts = [];
                      if (ch.removed && ch.removed.length)
                        parts.push(`removed ${ch.removed.join(", ")}`);
                      if (ch.added && ch.added.length)
                        parts.push(`added ${ch.added.join(", ")}`);
                      if (ch.standards_changed && ch.standards_changed.length)
                        parts.push(
                          `standards reassigned for ${ch.standards_changed.join(
                            ", "
                          )}`
                        );
                      detailText = parts.join("; ");
                    } else {
                      detailText = (va.persons || [])
                        .map(
                          (p) =>
                            `${p.name} (${
                              p.standards && p.standards.length
                                ? p.standards.join(", ")
                                : "no standard"
                            })`
                        )
                        .join("; ");
                    }
                    actionString = `Veto Person assignment ${modeText} by ${who}${
                      detailText ? " — " + detailText : ""
                    }`;
                  } else if (item.detail && item.detail.audit_execution) {
                    // Activity mirrored from the Audit Execution app (schedule
                    // creation & document data submissions) — see
                    // SIMCert-Audit-Execution-API item-log.repository.ts.
                    const ae = item.detail.audit_execution;
                    // Cycle-aware label: "(Certification Audit Stage 1)" /
                    // "(Surveillance Audit 1)". `stage` is only written for
                    // Certification Audit — the sole multi-stage cycle. Rows
                    // logged before audit_cycle existed fall back to stage only.
                    const cycleText = ae.audit_cycle
                      ? ` (${ae.audit_cycle}${
                          ae.stage ? ` Stage ${ae.stage}` : ""
                        })`
                      : ae.stage
                      ? ` Stage ${ae.stage}`
                      : "";
                    if (ae.activity === "schedule") {
                      actionString = `Audit schedule ${
                        ae.mode === "updated" ? "updated" : "submitted"
                      } by Scheduler ${who}`;
                    } else if (ae.activity === "lead-submission") {
                      actionString = `Audit documents${cycleText} submitted by Lead Auditor ${who} (${
                        ae.submitted_count
                      }/${ae.total_lead_auditors} Lead Auditors)${
                        ae.finalized ? " — fully submitted" : ""
                      }`;
                    } else {
                      actionString = `Audit document data${cycleText} ${
                        ae.mode === "draft" ? "saved as draft" : "submitted"
                      } by ${who}`;
                    }
                  } else {
                    actionString = `${entity} set to ${item.action.replace(
                      "to:",
                      ""
                    )} by ${who}`;
                  }

                  return (
                    <li key={item.id}>
                      <i className="fa fa-check activity-icon pull-left icon-success" />
                      <p style={{ marginBottom: 10 }}>
                        <span>
                          {actionString} - {createdAt.format("llll")}
                        </span>
                        <span
                          className="timestamp"
                          title={createdAt.format("D MMMM YYYY")}
                        >
                          {diffString}
                        </span>
                      </p>
                      {item.detail &&
                        (item.detail.remarks || item.detail.legal_document) && (
                          <div className="well">
                            {item.detail.remarks && (
                              <p>{item.detail.remarks}</p>
                            )}
                            {item.detail.file_name && (
                              <div>
                                <hr />
                                <a
                                  href={`${process.env.REACT_APP_BASE_API}/download/${item.detail.file_id}?token=${this.props.accessToken}`}
                                  className="btn btn-link btn-xs"
                                >
                                  <i className="fa fa-download" />{" "}
                                  {item.detail.file_name}
                                </a>
                              </div>
                            )}
                            {item.detail.legal_document && (
                              <div>
                                <hr />
                                <ul className="list-unstyled">
                                  {item.detail.legal_document.map((x, i) => (
                                    <li key={i}>
                                      {" "}
                                      <span>{x.detail.name} -</span>{" "}
                                      <a
                                        href={`${process.env.REACT_APP_BASE_API}/download/${x.id}?token=${this.props.accessToken}`}
                                        className="btn btn-link btn-xs"
                                      >
                                        <i className="fa fa-download" />{" "}
                                        Download
                                      </a>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            )}
                          </div>
                        )}
                    </li>
                  );
                })}
          </ul>
          {
            // <button type='button' className='btn btn-clean center-block'><i className='fa fa-refresh' /> Load more</button>
          }
        </div>
      </div>
    );
  }
}
